/*

Class for generating a provider

http://www.hl7.org/fhir/practitioner.html

{
  "state" : "<code>" // active || pending || archive || delete
  "orgId" : { String }
  "userId" : { String }
  "name" : [{ HumanName }], // The name(s) associated with the practitioner
  "sex" : "<code>", // male | female | transmale | transfemale | other | unknown
  "gender" : "<code>", // male | female | nonbinary | other | unknown
  "birthdate" : "<date>", // The date  on which the practitioner was born
  "telecom" : [{ ContactPoint }], // A contact detail for the practitioner (that apply to all roles)
  "qualification" : [{ // Certification, licenses, or training pertaining to the provision of care
    "identifier" : [{ Identifier }], // An identifier for this qualification for the practitioner
    "code" : { code }, // R!  Coded representation of the qualification
    "period" : { Period }, // Period during which the qualification is valid
    "issuer" : { Reference(Organization) } // Organization that regulates and issues the qualification
  }],
  "userType" : "<code>" // patient || providerAP || providerLP || orgAdmin || person
}

*/
// Import libraries
// const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');
const { User, userSchema} = require('./user.class');

// Create schema
const schema = {
  // provider AP specific validation params
  ...userSchema
};

// Define class
class ProviderAP extends User {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    obj.userType = 'providerAP';
    super( obj );
  }
}

exports.ProviderAP = ProviderAP;
exports.providerAPSchema = schema;